'use client';

import {
  CircleCheck,
  Info,
  LoaderCircle,
  OctagonX,
  TriangleAlert,
} from 'lucide-react';
import { Toaster as Sonner, toast, type ToasterProps } from 'sonner';

const CONFIRMATION_MS = 2200;
// Errors and warnings name the next step, so they stay long enough to read.
const READ_MS = 4000;
// Clears the sticky `.cta-bar-night` bars (bottom-safe-5, a 76px bar and an 8px gap).
const OFFSET = {
  bottom: 'calc(max(1.25rem, env(safe-area-inset-bottom)) + 84px)',
};

for (const kind of ['error', 'warning'] as const) {
  const show = toast[kind];
  toast[kind] = (message, data) =>
    show(message, { duration: READ_MS, ...data });
}

const Toaster = (props: ToasterProps) => (
  <Sonner
    theme="light"
    position="bottom-center"
    duration={CONFIRMATION_MS}
    offset={OFFSET}
    mobileOffset={OFFSET}
    icons={{
      success: <CircleCheck className="text-success size-4" />,
      error: <OctagonX className="text-danger size-4" />,
      warning: <TriangleAlert className="text-warning size-4" />,
      info: <Info className="text-info size-4" />,
      loading: <LoaderCircle className="text-dk-2 size-4 animate-spin" />,
    }}
    {...props}
  />
);

export { Toaster };
